<template>
  <div class="estimated-schedule-list">
    <!-- 前説明 -->
    <p v-t="'appEstimatedScheduleList.message.selectSchedule'" />
    <p v-t="'appEstimatedScheduleList.message.completeReportTask'" />
    <!-- 推定スケジュールリスト -->
    <div class="schedules-container">
      <b-row
        no-gutters
        v-for="schedule in sortedSchdules"
        v-bind:key="schedule.id"
        v-on:click="$_setValue(schedule.id)"
        class="schedule"
        v-bind:class="{ selected: value === schedule.id }"
      >
        <b-col cols="6" class="schedule-col date">
          {{ $_getDisplayPeriod(schedule) }}
        </b-col>
        <b-col class="schedule-col title">
          {{ schedule.title }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import SchedulePeriodFormatter from '@/js/SchedulePeriodFormatter.js'

// スケジュールのソート関数
const SCHEDULE_SORT_FUNCTION = (a, b) => {
  // 開始時間で比較
  if (!a.startAt.isSame(b.startAt)) {
    return b.startAt.isBefore(a.startAt) ? 1 : -1
  }
  // 終了時間で比較
  if (!a.endAt.isSame(b.endAt)) {
    return b.endAt.isBefore(a.endAt) ? 1 : -1
  }
  return 0
}

export default {
  name: 'AppScheduleConfirmList',
  props: {
    /**
     * 推定スケジュール
     */
    schedules: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      value: null,
    }
  },
  computed: {
    /**
     * ソート済みスケジュール
     * @type {Array.<Schedule>}
     */
    sortedSchdules: function () {
      return [...this.schedules].sort(SCHEDULE_SORT_FUNCTION)
    },
  },
  created: function () {
    this.formatter = new SchedulePeriodFormatter({
      allDayText: this.$t('appEstimatedScheduleList.allDay'),
    })
  },
  methods: {
    /**
     * 表示用期間を取得する
     *
     * @param {Schedule} schedule スケジュール
     * @returns {String} 表示用期間
     */
    $_getDisplayPeriod: function (schedule) {
      return this.formatter.format(schedule)
    },

    /**
     * 値をセットする
     * @param {Number} value 値
     */
    $_setValue: function (value) {
      this.value = value
    },

    /**
     * 値を取得する
     *
     * @returns {Number} 選択されたスケジュールID
     * @public
     */
    getValue: function () {
      return this.value
    },
  },
}
</script>

<style lang="scss" scoped>
.schedules-container {
  max-height: 40vh;
  overflow-y: scroll;
  @include mixin-scrollbar;
}

.schedule {
  min-height: 3.2em;
  padding: 10px 15px;
  background-color: #f4f5f6;
  border-top: 1px solid #ced4da;
  cursor: pointer;

  .schedule-col {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    font-weight: bold;

    &.date {
      color: $text-color-link;
      font-size: 0.8em;
      padding-right: 7.5px;
    }

    &.title {
      font-size: 0.9em;
      padding-left: 7.5px;
    }
  }

  &:hover {
    background-color: #e0e1e2;
  }

  &.selected {
    background-color: #b9d5fb;
  }

  &:last-child {
    border-bottom: 1px solid #ced4da;
  }
}
</style>
